// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_tableWrapper__Ug9H0 table th {
  font-size: 10px;
  background: #FFEDEA;
  font-weight: 600;
}

.table_tableWrapper__Ug9H0 table th:last-child div {
  text-align: right;
}

.table_tableWrapper__Ug9H0 table th div {
  font-size: 10px;
}

.table_tableWrapper__Ug9H0 table tr td {
  font-weight: 600;
  border-bottom: 1px solid var(--mui-palette-grey-300);
}`, "",{"version":3,"sources":["webpack://./src/components/most/list/history/item/suggested-tasks/table.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oDAAoD;AACtD","sourcesContent":[".tableWrapper table th {\n  font-size: 10px;\n  background: #FFEDEA;\n  font-weight: 600;\n}\n\n.tableWrapper table th:last-child div {\n  text-align: right;\n}\n\n.tableWrapper table th div {\n  font-size: 10px;\n}\n\n.tableWrapper table tr td {\n  font-weight: 600;\n  border-bottom: 1px solid var(--mui-palette-grey-300);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableWrapper": `table_tableWrapper__Ug9H0`
};
export default ___CSS_LOADER_EXPORT___;
